import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import {
  type ApiError,
  type ApiResponse,
  addActionNameToMutationResult,
  useAxiosInstance,
} from 'shared/hooks/utils';

const url = (termsAndConditionsId: number) => `/terms_and_conditions/${termsAndConditionsId}/pdf`;

export type DeleteTermsAndConditionsPDFVariables = {
  termsAndConditionsId: number;
};

export async function deleteTermsAndConditionsPDFFn(
  axiosInstance: Promise<AxiosInstance>,
  { termsAndConditionsId }: DeleteTermsAndConditionsPDFVariables,
) {
  const instance = await axiosInstance;

  return instance.delete(url(termsAndConditionsId));
}

export function useDeleteTermsAndConditionsPDF() {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, DeleteTermsAndConditionsPDFVariables>({
    mutationFn: variables => deleteTermsAndConditionsPDFFn(axiosInstance, variables),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['termsAndConditionsSettings'] });
      client.invalidateQueries({ queryKey: ['companyConfigurationV2'] });
    },
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    DeleteTermsAndConditionsPDFVariables,
    'deleteTermsAndConditionsPDF'
  >('deleteTermsAndConditionsPDF', mutation);
}
